import React from 'react';
import { StationDto } from '../../api/stations';

const TypeTag = (props: { station: any }) => {
  const {
    station
  } = props;
  const iconType = () => {

    let cls = '';
    if (station.operationMode === 1) {
      if (station.s4Num > 0) {
        cls = 'xpSuperFast';
      } else if (station.dcNum > 0) {
        cls = 'xpQuick';
      } else {
        cls = 'xpSlow';
      }
    } else if (station.operationMode === 3) {
      if (station.showPreferredPartnership) {
        cls = 'preferred_third';
      } else {
        cls = 'third';
      }
    } else {
      if (station.showPreferredPartnership) {
        cls = 'preferred_third';
      } else {
        cls = 'third';
      }
    }

    return cls;
  }
  return (
    <div className="tag-wrap">
      <div className={`${iconType()}`}></div>
    </div>
  )
};

export default TypeTag;
